import { useEffect } from "react";

const RequiredQuantityInput = ({
    index,
    register,
    watch,
    setValue,
    errors,
    trigger,
}) => {
    const numerator = watch(`bulk_order.${index}.numerator`);
    const denominator = watch(`bulk_order.${index}.denominator`);

    useEffect(() => {
        if (numerator && denominator && denominator !== 0) {
            const value = parseFloat(numerator) / parseFloat(denominator);
            if (!isNaN(value)) {
                setValue(`bulk_order.${index}.req_quan_of_item`, value);
            }
        }
    }, [numerator, denominator, index, setValue]);

    return (
        <div className="col-lg-6 col-md-6 col-sm-12">
            <label className="form-label">
                Required Quantity of Item
                <span className="fs-8 text-danger"> *</span>
            </label>

            <div className="row align-items-center">
                {/* Numerator */}
                <div className="col-2">
                    <input
                        type="number"
                        step={"any"}
                        className="form-control text-center"
                        {...register(`bulk_order.${index}.numerator`)}
                        onWheel={(e) => e.target.blur()}
                        onBlur={() =>
                            trigger(`bulk_order.${index}.req_quan_of_item`)
                        }
                    />
                </div>

                {/* Slash sign */}
                <div className="col-auto text-center fw-bold fs-4">/</div>

                {/* Denominator */}
                <div className="col-2">
                    <input
                        type="number"
                        step={"any"}
                        className="form-control text-center"
                        {...register(`bulk_order.${index}.denominator`, {
                            validate: {
                                positive: (value) =>
                                    value === "" ||
                                    parseFloat(value) !== 0 ||
                                    "Zero is not allowed",
                            },
                        })}
                        onWheel={(e) => e.target.blur()}
                        onBlur={() =>
                            trigger(`bulk_order.${index}.req_quan_of_item`)
                        }
                    />
                </div>

                {/* Equals sign */}
                <div className="col-auto text-center fw-bold fs-4">=</div>

                {/* Required Quantity (auto-calculated) */}
                <div className="col">
                    <div className="input-group">
                        <input
                            type="number"
                            step="any"
                            className="form-control text-center"
                            placeholder="Calculated quantity"
                            id="email-forms-req_quan_of_item"
                            {...register(
                                `bulk_order.${index}.req_quan_of_item`,
                                {
                                    required:
                                        "Required Quantity of Item is required",
                                    validate: {
                                        positive: (value) =>
                                            value > 0 ||
                                            "Only positive numbers are allowed",
                                    },
                                }
                            )}
                            onWheel={(e) => e.target.blur()}
                        />
                        {watch(`bulk_order.${index}.item_id`) && (
                            <div className="input-group-append">
                                <span
                                    className="input-group-text"
                                    id="basic-addon2"
                                >
                                    {watch(`bulk_order.${index}.item_id`)?.uom}
                                </span>
                            </div>
                        )}
                    </div>
                    {errors.bulk_order?.[index]?.req_quan_of_item && (
                        <span className="fs-8 text-danger">
                            {
                                errors.bulk_order?.[index]?.req_quan_of_item
                                    ?.message
                            }
                        </span>
                    )}
                </div>
            </div>
        </div>
    );
};

export default RequiredQuantityInput;
